import React,{useEffect} from "react";
// import { Link } from "react-scronll";
import "./mainservices.css";
import AOS from "aos"
import "aos/dist/aos.css"
import ResourcesMain from "../Resources/ResourcesMain";

const MainServicesComponent = ({
  icon = "",
  logo,
  image,
  sideImage,
  title = "",
  onItemClicked = () => console.error("You passed no action to the component"),
  isActive = false,
  id,
  name,
  scrollRef,
}) => {
  const getClassName = (id) => {
    if (isActive) {
      return `tabitemTab tabitemTab--active ${id}`;
    } else if (id === 1) {
      return `tabitemTab tabitemTab--id1 ${id}`;
    } else if (id === 2) {
      return `tabitemTab tabitemTab--id2 ${id}`;
    }

    return `tabitemTab tabitemTab--inactive ${id}`;
  };

  useEffect(() => {
    AOS.init({duration:1000}); 
  }, []);

  const getColorByTitle = (name) => {
    const colorMap = {
      raas: "#56cbe9",
      quiz: "#ca99ff",
      lms: "#0d108ba6",
      vlab: "#918cdc",
      ciso: "#0d6e66",
      asses_train: "#0276b0",
    };

    return colorMap[name] || "#fff";
  };

  const handleItemClick = () => {
    onItemClicked();
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <div className="service-component1">
      {/* <Link
        to={`section${id}`} // Provide the corresponding section's ID
        spy={true}
        smooth={true}
        duration={500}
        containerId="wrapperTab"
      > */}
      <div
        //   className={isActive ? "tabitemTab" : "tabitemTab tabitemTab--inactive"}
        // style={{ backgroundColor: getColorByTitle(name) }}
        className={`${getClassName(id)}  `}
        // onClick={onItemClicked}
        onClick={handleItemClick}
      >
        {/* <div className="box1">
          <div className="serviceLogo image">
            <img src={logo} />
          </div>
        </div> */}
        <div className="serviceIconImages" data-aos="fade-up">
          <img src={image} alt={name} />
        </div>
      </div>
      {/* </Link> */}
      {/* <p className="tabitem__title text-dark text-center">{title}</p> */}
    </div>
  );
};

export default MainServicesComponent;
